import {
  useCloudflareImage,
  useResponsiveCloudflareImage,
} from '@/hooks/useCloudflareImage';
import {
  RESPONSIVE_CONFIG,
  IMAGE_QUALITY,
  hasValidImage,
  createResponsiveBreakpoints,
} from './constants';

interface UseImageUrlsReturn {
  srcSet: string;
  placeholderUrl: string;
  mobileImageUrl: string;
}

export const useImageUrls = (src: string): UseImageUrlsReturn => {
  const isValidImage = hasValidImage(src);
  const responsiveBreakpoints = createResponsiveBreakpoints();

  // Use responsive hook for main image
  const { srcSet } = useResponsiveCloudflareImage({
    src: isValidImage ? src : '',
    breakpoints: responsiveBreakpoints,
  });

  // Use single hook for placeholder (different settings)
  const placeholderUrl = useCloudflareImage({
    src: isValidImage ? src : '',
    ...RESPONSIVE_CONFIG.mobile,
    quality: IMAGE_QUALITY.placeholder,
  });

  // Use single hook for mobile image (fallback src)
  const mobileImageUrl = useCloudflareImage({
    src: isValidImage ? src : '',
    ...RESPONSIVE_CONFIG.mobile,
  });

  return {
    srcSet,
    placeholderUrl,
    mobileImageUrl,
  };
};
